import { Link } from "react-router-dom";
import { channelGroups, channels } from "@/mocks/channels";
import { articles } from "@/mocks/articles";
import { toneClasses } from "@/lib/ui";

export default function ChannelGrid() {
  return (
    <div className="space-y-10">
      {channelGroups.map((group) => {
        const groupChannels = channels.filter((c) => c.group === group);
        return (
          <div key={group}>
            <div className="mb-4 flex items-center gap-3">
              <h3 className="font-heading text-lg font-bold text-foreground-950">{group}</h3>
              <span className="h-px flex-1 bg-background-200" />
              <span className="text-xs text-foreground-500">{groupChannels.length} 个栏目</span>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {groupChannels.map((channel) => {
                const tone = toneClasses[channel.tone];
                const count = articles.filter((a) => a.channel === channel.slug).length;
                return (
                  <Link
                    key={channel.slug}
                    to={`/pindao/${channel.slug}`}
                    className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
                  >
                    <div className="flex items-start justify-between">
                      <span
                        className={`flex h-11 w-11 items-center justify-center rounded-md ${tone.bgSoft} ${tone.textStrong}`}
                      >
                        <i className={`${channel.icon} text-xl`} />
                      </span>
                      <span className="flex items-center gap-1 text-xs text-foreground-400 transition-colors group-hover:text-primary-600">
                        进入板块
                        <i className="ri-arrow-right-line" />
                      </span>
                    </div>
                    <h4 className="mt-4 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                      {channel.name}
                    </h4>
                    <p className={`mt-1 text-xs font-medium ${tone.textSoft}`}>{channel.tagline}</p>
                    <p className="mt-3 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
                      {channel.description}
                    </p>
                    <div className="mt-4 flex flex-wrap gap-1.5">
                      {channel.highlights.map((h) => (
                        <span
                          key={h}
                          className="rounded bg-background-100 px-2 py-0.5 text-xs text-foreground-600"
                        >
                          {h}
                        </span>
                      ))}
                    </div>
                    <p className="mt-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
                      已有 <span className="font-medium text-foreground-800">{count}</span> 篇内容 · 位置：{channel.position}
                    </p>
                  </Link>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}